import { Guid } from 'guid-typescript';

export class ViewerModel {
    workId: string;
    id: string;
    name: string;
    fullUrl: string;
    features: string;

    constructor() {
        this.workId = Guid.EMPTY ;
        this.name = null;
        this.id = "";
        this.fullUrl = null;
        this.features = null;
    }
}

export function CreateBlankViewer(): ViewerModel {
    return new ViewerModel() ;
}
